import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { SelectedRowsCount } from './SelectedRowsCount';

type SelectionActionsFloatingBarProps = {
  count: number;
  children: ReactNode;
};

/** Centered floating bulk-actions bar that overlays the table without replacing the header. */
export const SelectionActionsFloatingBar = ({ count, children }: SelectionActionsFloatingBarProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 4,
        zIndex: 1002,
        display: 'flex',
        justifyContent: 'center',
        height: 0,
        overflow: 'visible',
        pointerEvents: 'none'
      }}
    >
      <Box
        sx={{
          pointerEvents: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2.5,
          py: 1.5,
          minHeight: 48,
          mt: 0.75,
          borderRadius: 2,
          bgcolor: 'background.paper',
          boxShadow: theme.shadows[4],
          border: `1px solid ${alpha(theme.palette.success.main, 0.12)}`,
          width: 'fit-content',
          maxWidth: 'calc(100% - 32px)'
        }}
      >
        <SelectedRowsCount count={count} />
        {children}
      </Box>
    </Box>
  );
};
